export interface VitolaItem {
  alias: string;
  shape: string;
  length: number;
  gauge: number;
}

export default class Vitola {
  alias: string;

  shape: string;

  length: number;

  gauge: number;

  static formattedName: ({
    alias,
    shape,
    size,
  }: {
    alias: string;
    shape: string;
    size: string;
  }) => string;

  constructor(item: VitolaItem) {
    this.alias = item.alias;
    this.shape = item.shape;
    this.length = item.length;
    this.gauge = item.gauge;
  }
}

Vitola.formattedName = ({
  alias,
  shape,
  size,
}: {
  alias: string;
  shape: string;
  size: string;
}) => {
  let name = '';
  if (alias && shape) {
    // Alias (Shape - Size)
    name = `${alias} (${shape} - ${size})`;
  } else if (alias && !shape) {
    // Alias (Size)
    name = `${alias} (${size})`;
  } else if (!alias && shape) {
    // Shape (Size)
    name = `${shape} (${size})`;
  } else {
    // Just size
    name = size;
  }
  return name;
};
